export default __webpack_public_path__ + "3dac3d4ecfc0637cc02ec3fc2b0fe497.mtl";